export const styles = theme => ({
    emptyTypography: {
        fontSize: 14,
        marginTop: '20px',
        color: 'rgba(0, 0, 0, 0.40)',
    },
    itemPaper: {
        backgroundColor: 'white !important',
        marginBottom: '2px',
        padding: '12px 20px',
        [theme.breakpoints.up('md')]: {
            padding: "25px 15px 25px 30px",
        }
    },
    badgeDiv: {
        marginTop: 5,
        fontSize: '.9rem',
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
            alignItems: 'center',
            marginRight: '15px',
            flexGrow: 0,
        }
    },
    badgeLabel: {
        [theme.breakpoints.up('md')]: {
            marginLeft: '5px'
        }
    },
    desktopLink: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'inline',
        }
    },
    mobileLink: {
        display: 'inline',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        }
    },
    flexGrowDiv: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        }
    },
    infoContainer: {
        marginTop: '7px',
        '& .rowColBlock': {
            display: 'flex',
            flexDirection: 'column',
            [theme.breakpoints.up('md')]: {
                flexDirection: 'row',
            }
        }
    },
    itemsPaper: {
        marginBottom: '5px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    sendButtonSpan: {
        marginTop: '10px',
        width: '98%',
        marginLeft: 'auto',
        marginRight: 'auto',
        [theme.breakpoints.up('md')]: {
            width: '100px',
            marginLeft: 'auto',
            marginRight: 'initial'
        }
    },
    snackBarClass: {
        width: '100%'
    },
    charactersLeft: {
        fontSize: '.8em',
    },
});
